// extracted by mini-css-extract-plugin
module.exports = {"root":"ad-b-module--root--17duJ","wrapper":"ad-b-module--wrapper--3u6Br","imgWrapper":"ad-b-module--imgWrapper--3mW8g","img":"ad-b-module--img--3APPF"};